import { FvcAnalysisSet, FvcAnalysisSetTest } from "webportalclient";
import { FvcTest } from "webportalclient";
import { IndividualAcceptabilityStatus } from "../../misc/api/apiTypes";
import { FvcTestAcceptabilitySummary } from "./PFTAPITypes";
import { calculateFvcRepeatabilityTopTwo, calculateFvcRepeatabilityTopTwoNew, FvcRepeatability } from "./RepeatabilityCalculations";

const repeatabilityTolerances = {
    gradeABUpperTier: 0.150,
    gradeABLowerTier: 0.100,
    gradeCUpperTier: 0.200,
    gradeCLowerTier: 0.150,
    gradeDUpperTier: 0.250,
    gradeDLowerTier: 0.200
}

export enum TestQualityGrade {
    none = "",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    U = "U",
    F = "F"
}

const repeatabilityTierAgeThreshold = 7;

export const calculateSessionGradingLegacy = (tests: FvcTestAcceptabilitySummary[], subjectAge: number, repeatabilitySelector: (parameter: FvcRepeatability) => number, repeatabilityPercentageSelector: (parameter: FvcRepeatability) => number) => {
    const v3AnalysisSetTests = tests.map(t => ({
        accepted: t.Accepted,
        test: {
            fvc: t.Fvc,
            fev1: t.Fev1,
            pefMin: t.PefMin,
            fef2575: t.Fef2575
        }
    } as FvcAnalysisSetTest));

    return calculateSessionGrading(v3AnalysisSetTests, subjectAge, repeatabilitySelector, repeatabilityPercentageSelector, IndividualAcceptabilityStatus.Hidden);
}

export const calculateSessionGrading = (analysisSetTests: FvcAnalysisSetTest[], subjectAge: number, repeatabilitySelector: (parameter: FvcRepeatability) => number, repeatabilityPercentageSelector: (parameter: FvcRepeatability) => number, individualAcceptabilities: IndividualAcceptabilityStatus) => {
    const acceptableTests = analysisSetTests.filter(ast => ast.accepted).length;

    const topTwo = calculateFvcRepeatabilityTopTwoNew(analysisSetTests, individualAcceptabilities);
    const repeatability = repeatabilitySelector(topTwo);
    const repeatabilityPercentage = repeatabilityPercentageSelector(topTwo);

    const repeatabilityPercentageThreshold = 10;
    const repeatabilityThresholdGradeAB = subjectAge >= repeatabilityTierAgeThreshold ? repeatabilityTolerances.gradeABUpperTier : repeatabilityTolerances.gradeABLowerTier;
    const repeatabilityThresholdGradeC = subjectAge >= repeatabilityTierAgeThreshold ? repeatabilityTolerances.gradeCUpperTier :repeatabilityTolerances.gradeCLowerTier;
    const repeatabilityThresholdGradeD = subjectAge >= repeatabilityTierAgeThreshold ? repeatabilityTolerances.gradeDUpperTier : repeatabilityTolerances.gradeDLowerTier;

    if ((repeatability <= repeatabilityThresholdGradeAB) || (subjectAge < repeatabilityTierAgeThreshold && repeatabilityPercentage <= repeatabilityPercentageThreshold)) {
        if (acceptableTests >= 3)
            return TestQualityGrade.A;

        if (acceptableTests === 2)
            return TestQualityGrade.B;
    }

    if ((repeatability <= repeatabilityThresholdGradeC || (subjectAge < repeatabilityTierAgeThreshold && repeatabilityPercentage <= repeatabilityPercentageThreshold)) && acceptableTests >= 2)
        return TestQualityGrade.C;

    if ((repeatability <= repeatabilityThresholdGradeD || (subjectAge < repeatabilityTierAgeThreshold && repeatabilityPercentage <= repeatabilityPercentageThreshold)) && acceptableTests >= 2)
        return TestQualityGrade.D;

    if ((repeatability > repeatabilityThresholdGradeD && acceptableTests >= 2))
        return TestQualityGrade.E;

    if (acceptableTests === 1)
        return TestQualityGrade.E;

    // TODO: TestQualityGrade U

    if(analysisSetTests.length != 0)
        return TestQualityGrade.F;

    return TestQualityGrade.none;
}
